/* Adtrip 10.2026: pole kodu rabatowego w koszyku i szufladzie (Cart API: POST /cart/update.js {discount}) */
(function () {
  if (customElements.get('cart-discount-code')) return;

  class CartDiscountCode extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.input = this.querySelector('input');
      this.errorEl = this.querySelector('[data-error]');
      this.codesEl = this.querySelector('[data-codes]');
      this.busy = false;
      if (this.form) this.form.addEventListener('submit', (e) => { e.preventDefault(); this.apply(); });
      this.addEventListener('click', (e) => {
        const b = e.target.closest('[data-remove]');
        if (b) { e.preventDefault(); this.remove(b.dataset.remove); }
      });
      // na podstronach Liquid nie zawsze zna kody z koszyka – dociągamy stan przy starcie
      if (window.AdtripCart && typeof window.AdtripCart.fetchCart === 'function') {
        window.AdtripCart.fetchCart().then((c) => {
          if (c && Array.isArray(c.discount_codes)) {
            this.applied = c.discount_codes.filter((x) => x.applicable).map((x) => x.code);
            this.renderCodes();
          }
        }).catch(() => {});
      }
      if (window.FoxThemeEvents) {
        this.unsub = window.FoxThemeEvents.subscribe('ON_CART_UPDATED', (state) => {
          if (state && Array.isArray(state.discount_codes)) {
            this.applied = state.discount_codes.filter((c) => c.applicable).map((c) => c.code);
            this.renderCodes();
          }
        });
      }
    }
    disconnectedCallback() { if (this.unsub) this.unsub(); }
    get applied() { return (this.dataset.applied || '').split(',').map((s) => s.trim()).filter(Boolean); }
    set applied(list) { this.dataset.applied = list.join(','); }
    helpers() { return window.AdtripCart; }
    setBusy(v) { this.busy = v; this.classList.toggle('is-busy', v); }
    showError(msg) {
      if (!this.errorEl) return;
      this.errorEl.textContent = msg || '';
      this.errorEl.hidden = !msg;
    }
    async post(codes) {
      const h = this.helpers();
      const url = `${(window.FoxThemeSettings && window.FoxThemeSettings.routes.cart_update_url) || '/cart/update'}.js`;
      return h.postCart(url, Object.assign({ discount: codes.join(',') }, h.sectionsRequest()));
    }
    async apply() {
      const code = (this.input && this.input.value || '').trim();
      if (!code || this.busy || !this.helpers()) return;
      this.setBusy(true);
      this.showError('');
      try {
        // poprzednie kody bierzemy ze świeżego stanu koszyka, nie z HTML (atrybut może być nieaktualny na podstronach)
        let prev = this.applied;
        try { const fresh = await this.helpers().fetchCart(); if (fresh && Array.isArray(fresh.discount_codes)) prev = fresh.discount_codes.filter((c) => c.applicable).map((c) => c.code); } catch (e) {}
        const list = prev.filter((c) => c.toLowerCase() !== code.toLowerCase()).concat([code]);
        let state = await this.post(list);
        const entry = (state.discount_codes || []).find((c) => String(c.code).toLowerCase() === code.toLowerCase());
        if (!entry || !entry.applicable) {
          state = await this.post(prev);
          this.showError(this.dataset.invalidText || 'Ten kod nie działa dla tego koszyka.');
        } else if (this.input) {
          this.input.value = '';
        }
        this.helpers().renderAll(state);
      } catch (e) {
        this.showError(this.dataset.errorText || 'Coś poszło nie tak. Spróbuj ponownie.');
      } finally {
        this.setBusy(false);
      }
    }
    async remove(code) {
      if (this.busy || !this.helpers()) return;
      this.setBusy(true);
      this.showError('');
      try {
        let current = this.applied;
        try { const fresh = await this.helpers().fetchCart(); if (fresh && Array.isArray(fresh.discount_codes)) current = fresh.discount_codes.filter((c) => c.applicable).map((c) => c.code); } catch (e) {}
        const state = await this.post(current.filter((c) => c.toLowerCase() !== String(code).toLowerCase()));
        this.helpers().renderAll(state);
      } catch (e) {
        this.showError(this.dataset.errorText || 'Coś poszło nie tak. Spróbuj ponownie.');
      } finally {
        this.setBusy(false);
      }
    }
    renderCodes() {
      if (!this.codesEl) return;
      const tpl = this.codesEl.dataset.chip || '';
      this.codesEl.innerHTML = this.applied.map((c) => tpl.split('__CODE__').join(c.replace(/[&<>"']/g, (ch) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[ch]))).join('');
    }
  }
  customElements.define('cart-discount-code', CartDiscountCode);
})();
